import { PaymentOrchestrationError } from "./PaymentOrchestrationError";
import { PaymentErrorCategories } from "./PaymentErrorCategories";

/**
 * Error thrown when payment handlers or gateways fail to initialize properly.
 * This is usually recoverable through reinitialization.
 */
export class PaymentInitializationError extends PaymentOrchestrationError {
  readonly category = PaymentErrorCategories.INITIALIZATION;
  readonly recoverable = true;

  constructor(
    technicalMessage: string,
    options?: {
      userMessage?: string;
      metadata?: Record<string, unknown>;
    }
  ) {
    super(technicalMessage, {
      userMessage:
        options?.userMessage ||
        "We're setting up your payment options. Please try again.",
      metadata: options?.metadata,
    });
  }
}
